import { callAPIContent } from '@utils/fetcher/content';
import { IParamRegister } from './register.types';

export const postRegisterFromAPI = (params: IParamRegister) => {
  const options = {
    method: 'POST',
    uri: 'register',
    params,
    servicePath: 'open/clients',
  };
  return callAPIContent(options);
};